export default "__VITE_ASSET__YVeqTj3d__"